import { connect } from "react-redux";
import BuddyLogo from "../../images/buddy-face.png";
import { Actions as ADVISOR_ACTIONS } from "../../store/actions/advisorActions";

const AdvisorAcceptInvite = ({ advisor, advisorId, acceptInvite, declineInvite }) => {
	return (
		<div
			className="block text-center bg-white"
			style={{ paddingTop: 120 }}
		>
			<div id="all-done">
				<div className="block-content block-content-full">
					<img
						src={BuddyLogo}
						style={{ width: "10rem" }}
					/>
				</div>
				<div className="main">
					<h1 className="font-w700 text-center">{advisor}</h1>
					<p className="text-center">{advisor} has invited you to operate on their advisory</p>
					<div style={{ display: "flex", justifyContent: "center" }}>
						<button
							className="btn btn-default"
							style={{ marginTop: "2rem" }}
							onClick={() => {
								declineInvite(advisorId);
							}}
						>
							Decline Invite
						</button>
						<button
							className="btn btn-primary"
							style={{ marginTop: "2rem", marginLeft: "2rem" }}
							onClick={() => {
                                acceptInvite(advisorId)
                            }}
						>
							Accept Invite
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		advisor: state.my?.profile?.advisorName,
        advisorId: state.my?.profile?.advisorId,
	};
};

const mapDispatchToProps = (dispatch) => ({
    acceptInvite: (id) => dispatch(ADVISOR_ACTIONS.acceptInvite(id)),
    declineInvite: (id) => dispatch(ADVISOR_ACTIONS.declineInvite(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvisorAcceptInvite);